/* global http pagination scrollToElement*/
const news = {
	el: {
		newsContainer: document.querySelector('.js-get-news')
	},

	vars: {
		currentPage: 1
	},

	fxGetNewsOnLoad() {
		const endpoint = this.el.newsContainer.dataset.endpoint,
			paginationList = this.el.newsContainer.nextElementSibling.querySelector('.pagination__list')

		const callback = response => {
			this.fxNewsCallback(response, '.media__list')
			pagination.fxPaginationHelper(response, paginationList)
			if (response.data.pagination.length > pagination.vars.maxPaginationItem)
				paginationList.querySelectorAll(`.pagination__item:nth-of-type(n+${pagination.vars.maxPaginationItem+1}`).forEach(el => el.classList.add('is-hidden'))
		}

		http.fxGet(endpoint, callback)
	},

	fxNewsCallback(response, selector) {
		const data = response.data
		document.querySelector(selector).innerHTML = ''

		if (document.querySelector(selector).closest('.js-get-news')) {
			data.results.forEach(el => {
				const date = new Date(el.date),
					formattedDate = new Date(el.date).toLocaleDateString(),
					getMonth = date.toLocaleDateString(this.el.newsContainer.dataset.language, { month: 'long' }),
					target = el.link.target === '_blank' ? el.link.target : '_self'

				document.querySelector(selector).innerHTML +=
					`
						<li class='media__item columns-2'>
							<div class='media__content'>
								<figure class='media__figure'>
									<img class='media__image img-full-width' src='${el.image}' alt='${el.title}'>
								</figure>
								<div class='media__content-block'>
									<div class='media__content-info epsilon'>
										<span class='media__content-text'>
											<time class='media__time' datetime='${formattedDate}'>${date.getDate()} ${getMonth}, ${date.getFullYear()}</time>
										</span>
										<span class='media__content-separator'>${el.source ? '&mdash;' : ''}</span>
										<span class='media__content-text'>${el.source}</span>
									</div>
									<h3 class='media__content-heading zeta'>${el.title}</h3>
									<a class='media__content-link arrow-animate' target='${target}' href='${el.link.url}'>
										${el.link.name}
										<svg class='button-icon-relative' xmlns='http://www.w3.org/2000/svg'>
											<path d='M14.5 8H17l3 4-3 4h-2.5l3-4-3-4z' fill-rule='evenodd' fill='#2D3134'></path>
											<path class='arrow-hovered' d='M18 13H4v-2h14v2z' fill-rule='evenodd' fill='#2D3134'></path>
										</svg>
									</a>
								</div>
							</div>
						</li>
					`
			})

			window.addEventListener('load', () => scrollToElement.fxScrollTo(document.querySelectorAll('.pagination__item, .pagination__button'), this))
		}
	},

	fxGetNewsPaginationItem() {
		document.addEventListener('click', e => {
			if (e.target && e.target.classList.contains('pagination__item') && e.target.offsetParent.querySelector('.js-get-news')) {
				e.target.closest('.pagination__list').querySelectorAll('.pagination__item').forEach(el => el.classList.remove('is-active'))
				e.target.classList.add('is-active')

				const endpoint = this.el.newsContainer.dataset.endpoint,
					paginationList = e.target.parentElement,
					page = Number(e.target.querySelector('button').textContent)

				const callback = response => this.fxNewsCallback(response, '.media__list--flex')

				http.fxGet(`${endpoint.substring(0, endpoint.lastIndexOf('/') + 1)}${page}`, callback).then(response => {
					this.vars.currentPage = response.data.pagination.filter(el => {
						if (el.currentPage) return el
					})[0].page
					pagination.fxPaginationItemHelper(response, paginationList, this.vars.currentPage)
				})
			}
		})
	},

	fxGetNewsNavigation() {
		pagination.el.paginationButtonPrev.forEach(el => el.addEventListener('click', e => {
			if (el.offsetParent.querySelector('.js-get-news')) {
				this.vars.currentPage--
				pagination.fxNavigationHelper(this.el.newsContainer.dataset.endpoint, '.media__list--flex', e.target.nextElementSibling, this.vars.currentPage)
			}
		}))

		pagination.el.paginationButtonNext.forEach(el => el.addEventListener('click', e => {
			if (el.offsetParent.querySelector('.js-get-news')) {
				this.vars.currentPage++
				pagination.fxNavigationHelper(this.el.newsContainer.dataset.endpoint, '.media__list--flex', e.target.previousElementSibling, this.vars.currentPage)
			}
		}))
	},

	init() {
		if (!this.el.newsContainer) return
		this.fxGetNewsOnLoad()
		this.fxGetNewsPaginationItem()
		this.fxGetNewsNavigation()
	}
}

news.init()